import { LoadingCircleImg } from "../../assets";

function LoadingCircle() {
  return <img className="w-6 h-6" src={LoadingCircleImg} />;
}

export default LoadingCircle;
